
import { Component, Injector, Input, OnInit } from '@angular/core';
import {
	ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
	SwitchControlSchema, DateTimeControlSchema
} from 'tnx-shared';
import { SubscriptionService } from 'tnx-admin-service/workflowcore/subscription/services';

@Component({
	selector: 'subscription-form',
	templateUrl: './subscription-form.component.html',
	styleUrls: ['./subscription-form.component.scss'],
	providers: [ComponentContextService],
})
export class SubscriptionFormComponent extends DataFormBase implements OnInit {

	constructor(
		protected _injector: Injector,
		private _subscriptionService: SubscriptionService
	) {
		super(_injector);
	}

	ngOnInit() {
		super.ngOnInit();
		this.setting.baseService = this._subscriptionService;
		this.setting.schema = <FormSchemaBase[]>[
			new TextControlSchema({
				field: 'persistenceId',
				label: ''
			}),
			new TextControlSchema({
				field: 'eventKey',
				label: ''
			}),
			new TextControlSchema({
				field: 'eventName',
				label: ''
			}),
			new TextControlSchema({
				field: 'stepId',
				label: ''
			}),
			new TextControlSchema({
				field: 'subscriptionId',
				label: ''
			}),
			new TextControlSchema({
				field: 'workflowId',
				label: ''
			}),
			new DateTimeControlSchema({
				field: 'subscribeAsOf',
				label: ''
			}),
			new TextControlSchema({
				field: 'currentStateCode',
				label: ''
			}),
			new TextControlSchema({
				field: 'code',
				label: ''
			})
		];
	}

	async onFormInitialized(formEvent: EventData) {
		// tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
	}

	async onFormEvent(evt) {
		// các event trong form
		console.log(evt);
	}

	async modifyDetailData(data) {
		// xử lý dữ liệu lấy từ get detail về
	}

	async onAfterGetDetail() {
		// xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
	}

	onBeforeSave() {
		// trước khi lưu
	}
}

